import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, StyleSheet, View } from 'react-native';
import { TWCButton } from '@components';

import { assets } from '@assets';
import { onboardingTestIDs, Theme } from '@constants';
import { useGetOnboardingLanding } from '@hooks';
import { navigationService } from '@services';

import { OnboardingBackgroundImage } from './OnboardingBackgroundImage';

import { TWCText } from '../../../components/primitives/TWCText/TWCText';

const tPath = 'welcomeBackPage.';

const SubscriberWelcomeBackPageContentAPI = () => {
  // We pre-fetch this feed on startup, so no need to handle loading state
  const { data } = useGetOnboardingLanding();

  return <SubscriberWelcomeBackPageContentUI data={data} />;
};

const SubscriberWelcomeBackPageContentUI = ({ data }) => {
  const { t } = useTranslation();

  return (
    <OnboardingBackgroundImage uri={data.backgroundImage}>
      <View style={styles.page}>
        <Image
          source={assets.twcLogo}
          style={styles.logoImage}
          testID={onboardingTestIDs.subscriberWelcomeBack.logoImage}
        />
        <TWCText
          style={styles.pageTitle}
          testID={onboardingTestIDs.subscriberWelcomeBack.pageTitle}
          variant={'boldText54'}
        >
          {t(`${tPath}title`)}
        </TWCText>
        <TWCText
          style={styles.welcomeParagraph}
          testID={onboardingTestIDs.subscriberWelcomeBack.welcomeBackMessage}
          variant={'regularText18'}
        >
          {t(`${tPath}welcomeBackMessage`)}
        </TWCText>
        <TWCButton
          accessibilityHint={t(`${tPath}agreeButtonHint`)}
          accessibilityLabel={t(`${tPath}agreeButtonLabel`)}
          style={styles.agreeButton}
          styleFocused={styles.agreeButton}
          testID={onboardingTestIDs.subscriberWelcomeBack.continueButton}
          textFocusStyle={styles.agreeButtonText}
          textStyle={styles.agreeButtonText}
          title={t(`${tPath}agreeButtonTitle`)}
          width={540}
          onPress={() => navigationService.navigate(onboardingTestIDs.pages.subscriptionSelectionPage)}
        />
        <TWCText
          style={styles.finePrint1}
          testID={onboardingTestIDs.subscriberWelcomeBack.finePrint1}
          variant={'regularText12'}
        >
          {t(`${tPath}finePrint1`)}
        </TWCText>
        <TWCText
          style={styles.finePrint2}
          testID={onboardingTestIDs.subscriberWelcomeBack.finePrint2}
          variant={'regularText12'}
        >
          {t(`${tPath}finePrint2`)}
        </TWCText>
      </View>
    </OnboardingBackgroundImage>
  );
};

export const SubscriberWelcomeBackPageContent = {
  API: SubscriberWelcomeBackPageContentAPI,
  UI: SubscriberWelcomeBackPageContentUI,
};

const styles = StyleSheet.create({
  agreeButton: {
    backgroundColor: Theme.dodgerBlue,
  },
  agreeButtonText: {
    color: Theme.mainText,
    fontFamily: 'Roboto-Medium',
    fontSize: Theme.px(18),
  },
  finePrint1: {
    height: Theme.px(34),
    lineHeight: Theme.px(18),
    marginBottom: Theme.px(10),
    marginTop: Theme.px(22),
    width: Theme.px(407),
  },
  finePrint2: {
    height: Theme.px(16),
    lineHeight: Theme.px(18),
    width: Theme.px(300),
  },
  logoImage: {
    height: Theme.px(150),
    marginBottom: Theme.px(23),
    width: Theme.px(150),
  },
  page: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: Theme.px(120),
    paddingTop: Theme.px(205),
  },
  pageTitle: {
    color: Theme.white,
    marginBottom: Theme.px(23),
  },
  welcomeParagraph: {
    height: Theme.px(101),
    lineHeight: Theme.px(30),
    marginBottom: Theme.px(3),
    width: Theme.px(854),
  },
});
